export default "__VITE_ASSET__B1TNK7dK__"